import { render } from "./StoryCard.vue?vue&type=template&id=69e8c29e&scoped=true"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"

import "./StoryCard.vue?vue&type=style&index=0&id=69e8c29e&scoped=true&lang=css"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e8c29e"]])

export default __exports__